/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestDto } from '../../models/contents-request-dto';
import { UpdateContentsRequestDto } from '../../models/update-contents-request-dto';

export interface ContentsRequestControllerStatusUpdate$Params {
  id: string;
      body: UpdateContentsRequestDto
}

export function contentsRequestControllerStatusUpdate(http: HttpClient, rootUrl: string, params: ContentsRequestControllerStatusUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerStatusUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestDto>;
    })
  );
}

contentsRequestControllerStatusUpdate.PATH = '/api/contents-request/{id}/status';
